'use strict';

var luxon = require('luxon');
var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'dateString';
const DATE_STRING_ERROR = 'invalidDateString';
const DEFAULT_FORMAT = 'MM/dd/yyyy';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? DATE_STRING_ERROR
        },
        test: (value)=>/**
         * Test the chosen format where the year has no leading zeros,
         * then check if the given date is valid.
         */ value ? /^\d{2}\/\d{2}\/[1-9]\d{3}$/.test(value) && luxon.DateTime.fromFormat(value, options?.format ?? DEFAULT_FORMAT).isValid : true
    });
});

exports.DATE_STRING_ERROR = DATE_STRING_ERROR;
exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
//# sourceMappingURL=dateString.js.map
